
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "./components/ui/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import { AppLayout } from "@/components/layout/AppLayout";
import { PrivateRoute } from "@/components/auth/PrivateRoute";
import Index from "@/pages/Index";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import Knowledge from "@/pages/Knowledge";
import Users from "@/pages/Users";
import MotorApi from "@/pages/MotorApi";
import DataOneApi from "@/pages/DataOneApi";
import Analysis from "@/pages/Analysis";
import OpenAIResources from "@/pages/OpenAIResources";
import Calibration from "@/pages/Calibration";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import LogicEngine from './pages/LogicEngine';
import QuickCompare from './pages/QuickCompare';
import VinTestPage from "@/components/vin/VinTest";
import AzureExtraction from "@/pages/AzureExtraction";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="everest-theme">
        <Router>
          <Routes>
            {/* Home route uses AppLayout directly (no auth required) */}
            <Route path="/" element={<AppLayout><Index /></AppLayout>} />
            <Route path="/auth" element={<Auth />} />
            
            {/* All other routes require authentication */}
            <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />
            <Route path="/knowledge" element={<PrivateRoute><Knowledge /></PrivateRoute>} />
            <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
            <Route path="/motor-api" element={<PrivateRoute><MotorApi /></PrivateRoute>} />
            <Route path="/dataone-api" element={<PrivateRoute><DataOneApi /></PrivateRoute>} />
            <Route path="/analysis" element={<PrivateRoute><Analysis /></PrivateRoute>} />
            <Route path="/openai" element={<PrivateRoute><OpenAIResources /></PrivateRoute>} />
            <Route path="/calibration" element={<PrivateRoute><Calibration /></PrivateRoute>} />
            <Route path="/logic-engine" element={<PrivateRoute><LogicEngine /></PrivateRoute>} />
            <Route path="/quick-compare" element={<PrivateRoute><QuickCompare /></PrivateRoute>} />
            <Route path="/vin-test" element={<PrivateRoute><VinTestPage /></PrivateRoute>} />
            <Route path="/azure-extraction" element={<PrivateRoute><AzureExtraction /></PrivateRoute>} />
            
            {/* Public routes */}
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
          <Toaster />
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
